import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  wallet: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  paymentCode: "",
  rebate: {
    data: [],
    total_rebate: "",
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  topUpSuccess: false
};

export default function WalletReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Wallet
    case actionTypes.GET_WALLET_TRANSACTION_LIST: {
      let wallet = { ...state.wallet };
      wallet.offset = action.data.offset;
      wallet.limit = action.data.limit;
      return {
        ...state,
        wallet: wallet
      };
    }
    case actionTypes.GET_WALLET_TRANSACTION_LIST_SUCCESS: {
      let wallet = { ...state.wallet };
      wallet.data = action.data.data;
      wallet.meta = {
        page: 1 + state.wallet.offset / state.wallet.limit,
        pageSize: state.wallet.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.wallet.limit),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        wallet: wallet
      };
    }
    // Payment Code
    case actionTypes.GET_WALLET_PAYMENT_CODE: {
      return {
        ...state,
        paymentCode: {
          data: "",
          success: false
        }
      };
    }
    case actionTypes.GET_WALLET_PAYMENT_CODE_SUCCESS: {
      return {
        ...state,
        paymentCode: {
          data: action.data.data,
          success: true
        }
      };
    }
    // Rebate
    case actionTypes.GET_WALLET_REBATE_LIST: {
      let rebate = { ...state.rebate };
      rebate.offset = action.data.offset;
      rebate.limit = action.data.limit;
      return {
        ...state,
        rebate: rebate
      };
    }
    case actionTypes.GET_WALLET_REBATE_LIST_SUCCESS: {
      let rebate = { ...state.rebate };
      rebate.data = action.data.data;
      rebate.total_rebate = action.data.total_rebate;
      rebate.meta = {
        page: 1 + state.rebate.offset / state.rebate.limit,
        pageSize: state.rebate.limit,
        pageTotal: Math.ceil(action.data.recordsTotal / state.rebate.limit),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        rebate: rebate
      };
    }
    // Top Up
    case actionTypes.LOAD_WALLET_TOP_UP:
    case actionTypes.LOAD_WALLET_TOP_UP_FAIL:
      return {
        ...state,
        topUpSuccess: INITIAL_STATE.topUpSuccess
      };

    case actionTypes.LOAD_WALLET_TOP_UP_SUCCESS:
      return {
        ...state,
        topUpSuccess: true
      };

    default:
      return state;
  }
}
